module.exports = __webpack_public_path__ + "img/lt.6d0c1e5f.svg";